<template>
  <div class="pc_button">
    <div>
      <el-button
        class="button"
        :disabled="disabled"
        @click="handleSubmit">{{ btnTitle }}</el-button>
    </div>
  </div>
</template>

<script>
// import { ref, toRef, onMounted } from '@vue/composition-api'
// // import { vm } from '@/libs/lang'
import { vm } from '@/locales'
export default {
  name: 'PCButton',
  props: {
    disabled: {
      type: Boolean,
      default: true
    },
    btnTitle: {
      type: String,
      default: vm.$t('PCButton.index.646zhxujd5g0')
      // default: vm.$t('ep.lookEp') // '查看估价'
    }
  },
  data() {
    return {
    };
  },
  methods: {
    handleSubmit() {
      this.$emit('handleSubmit');
    }
  }
};
</script>

<style scoped lang="less">
.pc_button {
  text-align: right;
  margin-top: 20px;
  /deep/ .el-button {
    margin-right: 16px;
    min-width: 200px;
    height: 48px;
    background-color: #FF8A14 !important;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    border-radius: 4px;
    border: none;
  }
  .is-disabled {
    background-color: #ffd0a1 !important;
  }
  /deep/.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{
    color: #fff;
  }
}
</style>
